var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadminton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30078 15.2981C6.30078 16.7905 7.51007 17.9998 9.00249 17.9998C10.4949 17.9998 11.7042 16.7905 11.7042 15.2981V13.4985H6.30078V15.2981Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1958 0.902168L14.3963 0L12.5968 0.902168L10.7972 0L8.99768 0.902168L7.19815 0L5.39861 0.902168L3.59907 0L1.79954 0.902168L0 0L6.30078 11.6946H11.6994L17.9954 0L16.1958 0.902168Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadminton);
export default __webpack_public_path__ + "static/media/badminton.d63590f4c56bbda52bc92c24f9dd96a1.svg";
export { ForwardRef as ReactComponent };